export function OfflineBadge({ className = '' }: { className?: string }) {
  return (
    <span className={`inline-flex items-center gap-1 text-xs text-red-600 ${className}`.trim()}>
      <span aria-hidden="true" className="inline-block h-1.5 w-1.5 rounded-full bg-red-500" />
      offline
    </span>
  );
}
